import { htmlToText } from "html-to-text";

import { HTML_TO_TEXT_OPTIONS } from "./strip-html-string";

/**
 * Plain-text version of a CMS rich-text field, for use as a JSON-LD value. Unlike `stripHtmlString`
 * it keeps the full text: a structured-data value is not a preview, and truncating one would put a
 * different description in the markup than the page shows.
 */
export const stripHtmlForSchema = (html?: string): string | undefined => {
  if (!html) return undefined;

  const text = htmlToText(html, HTML_TO_TEXT_OPTIONS).replace(/\s+/g, " ").trim();

  return text || undefined;
};
